import Helmet from 'react-helmet'
import * as React from 'react'

const WebComponentFussballliebe = () => {
  const module = process.env.FUSSBALLLIEBE_HOST + '/fussballliebe.es.js'
  const style = process.env.FUSSBALLLIEBE_HOST + '/fussballliebe.css'
  const image = process.env.FUSSBALLLIEBE_IMAGE

  const [isClient, setIsClient] = React.useState(false)

  React.useEffect(() => {
    setIsClient(true)
  }, [])

  // We are doing this, because SSR won't render the content of the webcomponent and we would get a hydration error.
  if (!isClient) return null

  return (
    <>
      <Helmet>
        <script type="module" src={module} />
        <link rel="stylesheet" href={style} />
      </Helmet>
      <fussball-liebe
        bgimagesrc={image}
        bgimagealt="Aufmacherbild"
        headline="Fußballliebe kennt keine Tabus: Was bewegt dich?"
        subline="Sag uns dein wichtigstes Thema und wir bringen es auf den DFB-Tisch."
      ></fussball-liebe>
    </>
  )
}

export default WebComponentFussballliebe
